import { render, staticRenderFns } from "./SplashScreenV2.vue?vue&type=template&id=51c52da8&scoped=true"
import script from "./SplashScreenV2.vue?vue&type=script&lang=js"
export * from "./SplashScreenV2.vue?vue&type=script&lang=js"
import style0 from "./SplashScreenV2.vue?vue&type=style&index=0&id=51c52da8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c52da8",
  null
  
)

export default component.exports